import React from 'react'
import Layout from '../../components/Layout/Layout'
import { Link } from 'react-router-dom'
import styles from './ConfirmInfo.module.css'

const ConfirmInfo = () => {
    return (
        <Layout title="Confirm Info" route={"/courier-info"}>
            <div className={styles.container}>
                <div className={styles.directionsContainer}>
                    <div className={styles.iconsContainer}>
                        <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                        <span className={styles.line}></span>
                        <i className={styles.icon + " fas fa-location-arrow"}></i>
                    </div>
                    <div className={styles.places}>
                        <div className={styles.place}>
                            <small>Walmart</small>
                            <h2>Emili Williamson</h2>
                            <p>128 Mott St. New York, NY 10013, United States.</p>
                        </div>
                        <div className={styles.place}>
                            <small>City Garden</small>
                            <h2>Samantha Williamson</h2>
                            <p>128 Mott St. New York, NY 10013, United States.</p>
                        </div>
                    </div>
                </div>

                <div className={styles.distanceContainer}>
                    <div className={styles.distance}>
                        <small>Distance</small>
                        <p>24.2 km</p>
                    </div>
                    <div className={styles.viewMap}>
                        <i className={styles.icon + " fas fa-location-arrow"}></i>
                        <p>View in Map</p>
                    </div>
                </div>

                <div className={styles.infoContainer}>
                    <div className={styles.box}>
                        <small>Courier Type</small>
                        <p>Box Courier</p>
                    </div>
                    <div className={styles.box}>
                        <small>Frangible</small>
                        <p>Yes</p>
                    </div>
                    <div className={styles.box}>
                        <small>Height Weight Length</small>
                        <p>60 x 75 x 124 (cm)</p>
                    </div>
                    <div className={styles.box}>
                        <small>Weight</small>
                        <p>10 kg</p>
                    </div>
                    <div className={styles.box}>
                        <small>Courier Info</small>
                        <p>Birthday Gift containing flower Vaas, Carry carefully as it is frangible.</p>
                    </div>
                </div>
                <Link to="/payment-modes">
                    <button className={styles.continueBtn}>
                        Proceed to Payment
                        <i className={styles.icon + " fas fa-long-arrow-alt-right"}></i>
                    </button>
                </Link>
            </div>
        </Layout>
    )
}

export default ConfirmInfo
